// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collections-structure-collection-select-item {
  display: flex;
  align-items: center;
  padding: 8px 6px;
  margin-bottom: 4px;
  border-radius: 8px;
  cursor: pointer;
}
.dl-collections-structure-collection-select-item:last-child {
  margin-bottom: 0;
}
.dl-collections-structure-collection-select-item:hover {
  background-color: var(--g-color-base-simple-hover);
}
.dl-collections-structure-collection-select-item_inactive {
  opacity: 0.5;
  cursor: not-allowed;
}
.dl-collections-structure-collection-select-item_inactive:hover {
  background-color: transparent;
}
.dl-collections-structure-collection-select-item_active {
  background-color: var(--g-color-base-simple-hover);
}
.dl-collections-structure-collection-select-item__title {
  flex: 1;
  margin-left: 8px;
}
.dl-collections-structure-collection-select-item__entry-icon {
  width: 20px;
  height: 20px;
}
.dl-collections-structure-collection-select-item__entry-icon .custom-color-box {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CollectionStructureDialog/StructureItemSelect/Item/Item.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACJ;AACI;EACI,gBAAA;AACR;AAEI;EACI,kDAAA;AAAR;AAGI;EACI,YAAA;EACA,mBAAA;AADR;AAGQ;EACI,6BAAA;AADZ;AAKI;EACI,kDAAA;AAHR;AAMI;EACI,OAAA;EACA,gBAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;AALR;AAMQ;EACI,WAAA;EACA,YAAA;AAJZ","sourcesContent":[".dl-collections-structure-collection-select-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 6px;\n  margin-bottom: 4px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.dl-collections-structure-collection-select-item:last-child {\n  margin-bottom: 0;\n}\n.dl-collections-structure-collection-select-item:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.dl-collections-structure-collection-select-item_inactive {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.dl-collections-structure-collection-select-item_inactive:hover {\n  background-color: transparent;\n}\n.dl-collections-structure-collection-select-item_active {\n  background-color: var(--g-color-base-simple-hover);\n}\n.dl-collections-structure-collection-select-item__title {\n  flex: 1;\n  margin-left: 8px;\n}\n.dl-collections-structure-collection-select-item__entry-icon {\n  width: 20px;\n  height: 20px;\n}\n.dl-collections-structure-collection-select-item__entry-icon .custom-color-box {\n  width: 20px;\n  height: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
